import React from "react";

export const PURCHASE_INTENT_OPTIONS = [
  { value: "unknown", label: "Sans information", className: "border-[var(--do-border)] bg-[var(--do-bg-2)] text-[var(--do-muted)]" },
  {
    value: "within_three_months",
    label: "Moins de 3 mois",
    className:
      "border-[var(--do-accent)] bg-[var(--do-accent)] text-[var(--do-on-accent)]",
  },
  {
    value: "three_to_six_months",
    label: "Entre 3 et 6 mois",
    className:
      "border-[var(--do-border)] bg-[var(--do-accent-soft)] text-[var(--do-accent)]",
  },
  {
    value: "over_six_months",
    label: "Plus de 6 mois",
    className:
      "border-[var(--do-border)] bg-[var(--do-bg-2)] text-[var(--do-muted)]",
  },
  {
    value: "no_current_project",
    label: "Pas de projet actuellement",
    className:
      "border-[var(--do-border)] bg-[var(--do-bg-2)] text-[var(--do-muted)]",
  },
  {
    value: "not_interested",
    label: "Pas intéressé",
    className:
      "border-[var(--do-border)] bg-[var(--do-bg-2)] text-[var(--do-muted)]",
  },
  {
    value: "competition",
    label: "À la concurrence",
    className:
      "border-[var(--do-danger)] bg-[var(--do-danger-soft)] text-[var(--do-ink)]",
  },
];

const LEGACY_PURCHASE_INTENTS = {
  one_month: "within_three_months",
  three_months: "within_three_months",
  six_months: "three_to_six_months",
  lost: "competition",
  project_completed: "unknown",
  project_abandoned: "unknown",
};

export function normalizePurchaseIntent(value) {
  const normalized = String(value || "").trim();

  return LEGACY_PURCHASE_INTENTS[normalized] || normalized || "unknown";
}

export function getPurchaseIntent(value) {
  const normalized = normalizePurchaseIntent(value);

  return (
    PURCHASE_INTENT_OPTIONS.find(
      (option) => option.value === normalized
    ) || null
  );
}

export default function PurchaseIntentBadge({
  value,
  emptyLabel = "—",
  className = "",
}) {
  const intent = getPurchaseIntent(value);

  if (!intent) {
    return (
      <span
        className={`text-sm text-[var(--do-muted)] ${className}`}
        data-testid="purchase-intent-empty"
      >
        {emptyLabel}
      </span>
    );
  }

  return (
    <span
      className={`inline-flex max-w-full items-center rounded-full border px-2.5 py-1 text-xs font-black leading-none ${intent.className} ${className}`}
      data-testid={`purchase-intent-${intent.value}`}
    >
      {intent.label}
    </span>
  );
}